export enum ListItemComponentType {
  DIV = "div",
  LI = "li",
  A = "a"
}
